import type { CityPageCategoryShare } from "@noko-city/shared";

/**
 * Copy for the guide's non-authored blocks. These are editorial definitions of a
 * category — never counts, popularity claims, venues or dates: the aggregates
 * behind the ranking stay backend-side and the events themselves stay on
 * Instagram.
 */

/** One short paragraph per seeded event-category slug (see the EventCategories migration). */
export const EVENT_TYPE_DESCRIPTIONS: Readonly<Record<string, string>> = {
  "live-music":
    "Somewhere in the city a band is setting up right now. The acts, the rooms and the start times are on Instagram.",
  "dj-club":
    "Late, loud, and somebody else is picking the music. Instagram has the line-ups and the times the doors open.",
  "food-drink":
    "A table, a plate you did not cook, and people to eat it with. The where and the when are on Instagram.",
  "art-exhibition":
    "Rooms you walk through slowly, with the work on the walls. Instagram lists what is hanging and when to go.",
  theatre:
    "A stage, a story, and a room that goes quiet at the same moment. Instagram carries the plays and the language they are performed in.",
  film: "Watching a film with other people is the point of going out for one. Instagram has the screenings and their start times.",
  comedy:
    "One person, a microphone, and a room hoping for the punchline. Instagram has the line-ups and the door times.",
  market:
    "Stalls to browse and things somebody made by hand. Instagram shows the markets and the days they run.",
  sports:
    "Watching from the stands or joining in yourself. Instagram explains what is on and how to take part.",
  workshop:
    "You leave knowing how to do the thing you came for. Instagram has the subjects, the levels and what to bring.",
  community:
    "A reason to be in a room with people you have not met yet. Instagram shows what each gathering is.",
  festival:
    "Several stages, a weekend, and no way to see all of it. Instagram carries the programme and the practical bits.",
};

/** The paragraph shown for a category the table does not know yet. */
export function eventTypeDescription(share: CityPageCategoryShare): string {
  return (
    EVENT_TYPE_DESCRIPTIONS[share.slug] ??
    `For ${share.name}, the details are in the city's Instagram posts.`
  );
}
